import { render, staticRenderFns } from "./BasicEduTeacherResource.vue?vue&type=template&id=6a230937"
import script from "./BasicEduTeacherResource.vue?vue&type=script&lang=js"
export * from "./BasicEduTeacherResource.vue?vue&type=script&lang=js"
import style0 from "./BasicEduTeacherResource.vue?vue&type=style&index=0&id=6a230937&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports